import { Store } from 'stores/type';
import EventsManager from 'managers/events.manager';

class StatsManager {
  private $store!: Store;

  public init(store: Store) {
    this.$store = store;

    EventsManager.once('PLAY', () => this.setInitial());
  }

  public setInitial() {
    this.$store.dispatch('statsSessionsCount');
    this.$store.dispatch('statsInitialProgress');
  }
}

export default new StatsManager();
